function injectStyle (ssrContext) {
  require("!!../_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../_vue-loader@12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6c0cb5c8\",\"scoped\":true,\"hasInlineConfig\":false}!../_vue-loader@12.2.2@vue-loader/lib/selector?type=styles&index=0!./vue-datepicker-es6.vue")
}
var Component = require("!../_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./vue-datepicker-es6.vue"),
  /* template */
  require("!!../_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6c0cb5c8\",\"hasScoped\":true}!../_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./vue-datepicker-es6.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c0cb5c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-datepicker@1.3.0@vue-datepicker/vue-datepicker-es6.vue
// module id = 688
// module chunks = 107